module.exports = __webpack_public_path__ + "./docs/img/big-icon-events.37b55fc063ad5c8a5e90a2bb51e86b49.svg";